import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { OOCanvas } from 'src/app/shared/models/oo-canvas';

@Component({
	selector: 'app-canvas-list',
	templateUrl: './canvas-list.component.html',
	styleUrls: ['../../../commandcenter.scss'],
})
export class CanvasListComponent implements OnInit {
	canvasList: OOCanvas[];
	canvasListSubscription: Subscription = new Subscription();

	constructor(public app: AppService, public venueService: OOVenueService, private focuslink: FocuslinkService, private router: Router) {}

	ngOnInit(): void {
		if (this.venueService.canvasList.value.length === 0) {
			this.canvasListGet(this.venueService.subscriptionVenue.value.key);
		} else {
			this.canvasList = [...this.venueService.canvasList.value];
		}

		this.canvasListSubscription.add(
			this.venueService.canvasList.subscribe((canvasList) => {
				if (canvasList.length > 0) {
					this.canvasList = [...canvasList];
				}
			})
		);
	}

	async canvasListGet(venueKey) {
		const resp = await this.focuslink.menuCanvasGetAllMinified(venueKey);
		this.venueService.canvasSet(resp.map((i) => new OOCanvas(i)));
	}

	canvasSelect(canvasKey: number) {
		this.router.navigate([`/cc/canvases/${canvasKey}`]);
	}
}
